if (!customElements.get("variant-sofa-bed-options")) {
  customElements.define(
    "variant-sofa-bed-options",
    class VariantSofaBedOptions extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.section = this.closest("section");
        this.addEventListener("change", (event) => {
          this.updateSummary(event.target);
          this.clearError();
        });
        this.section?.addEventListener("variantChangeEnd", (event) => {
          const picker = event.target.closest("variant-options") || event.target;
          const variantId = picker.currentVariant?.id || picker.dataset.variantId;
          if (variantId) this.updateForVariant(String(variantId));
        });
        this.section?.addEventListener("variantProductInfoRendered", (event) => {
          const variantId = event.detail?.variant?.id;
          if (variantId) this.updateForVariant(String(variantId));
        });
        this.querySelectorAll("select, input[type=radio]:checked").forEach((control) => this.updateSummary(control));
        this.updateForVariant(String(this.dataset.selectedVariantId || ""));
      }

      updateForVariant(variantId) {
        let visibleGroup = null;
        this.querySelectorAll("[data-sofa-bed-options-for]").forEach((group) => {
          const show = group.dataset.sofaBedOptionsFor === variantId;
          group.hidden = !show;
          group.querySelectorAll("select, input[type=radio]").forEach((control) => {
            control.disabled = !show;
          });
          if (!show) group.querySelectorAll("details").forEach((details) => { details.open = false; });
          if (show) visibleGroup = group;
        });
        this.hidden = !visibleGroup;
        this.clearError();
      }

      validateSelection() {
        const group = this.querySelector("[data-sofa-bed-options-for]:not([hidden])");
        if (!group) return true;
        const invalid = [...group.querySelectorAll("[data-sofa-bed-option-set]")].find((set) => {
          const select = set.querySelector("select");
          if (select) return !select.value;
          return !set.querySelector("input[type=radio]:checked");
        });
        if (!invalid) return true;

        const error = group.querySelector("[data-sofa-bed-options-error]");
        if (error) error.hidden = false;
        const accordion = invalid.closest("details");
        if (accordion) accordion.open = true;
        window.requestAnimationFrame(() => invalid.querySelector("select, input[type=radio]")?.focus());
        return false;
      }

      updateSummary(control) {
        const accordion = control?.closest("details");
        if (!accordion) return;
        const summary = accordion.querySelector("[data-sofa-bed-selected-label]");
        if (!summary) return;
        const select = accordion.querySelector("select");
        const value = select?.selectedOptions?.[0]?.textContent?.trim()
          || accordion.querySelector("input[type=radio]:checked")?.value
          || "Select an option";
        summary.textContent = value;
      }

      applySelection(form) {
        const group = this.querySelector("[data-sofa-bed-options-for]:not([hidden])");
        this.setProperty(form, "Foot Option", this.selectedValue(group, "data-sofa-bed-foot-option"), "footOption");
        this.setProperty(form, "Delivery Accessibility", this.selectedValue(group, "data-sofa-bed-accessibility-option"), "deliveryAccessibility");
      }

      selectedValue(group, attribute) {
        if (!group) return "";
        const select = group.querySelector(`select[${attribute}]`);
        if (select) return select.value || "";
        return group.querySelector(`input[${attribute}]:checked`)?.value || "";
      }

      setProperty(form, name, value, dataKey) {
        let property = form.querySelector(`[data-sofa-bed-property="${dataKey}"]`);
        if (!property) {
          property = document.createElement("input");
          property.type = "hidden";
          property.name = `properties[${name}]`;
          property.dataset.sofaBedProperty = dataKey;
          form.appendChild(property);
        }
        property.value = value;
        property.disabled = !value;
      }

      clearError() {
        this.querySelectorAll("[data-sofa-bed-options-error]").forEach((error) => {
          error.hidden = true;
        });
      }
    }
  );
}
